import clsx from "clsx";

import ImgPc from "$/images/campaign/freeDeliveryfee/bnr_freedelivery_pc.jpg";
import ImgSp from "$/images/campaign/freeDeliveryfee/bnr_freedelivery_sp.jpg";

import { ProductLargeImage } from "../../product/ProductLargeImage";

export function FreeShippingCampaign(): React.ReactNode {
  return (
    <div>
      <ProductLargeImage
        spImage={{
          src: ImgSp,
          alt: "新生活応援セール 送料無料",
        }}
        pcImage={{
          src: ImgPc,
          alt: "コース初回・再開者限定",
        }}
        full="true"
      />
      <p className={clsx("text__s", "text__gray__dark", "mg__top__m")}>
        ※2025/6/4
        14時まで（システム反映により前後する場合あり）、公式オンラインショップのみ対象です。※継続コース初回の常温便送料500円が無料、冷凍便は対象外。2回目以降は送料がかかります。※継続コースを初めて購入する方、過去に購入したがすでに解約済の方（常温便・冷凍便ともに解約済）限定です。
      </p>
    </div>
  );
}
